import { useT } from "@/lib/i18n";

export default function Disclaimer() {
  const { t } = useT();
  return (
    <div
      className="mt-6 rounded-lg border border-[#272A35] bg-[#0C0E14] px-4 sm:px-5 py-4 text-xs md:text-sm text-slate-400 leading-relaxed"
      data-testid="disclaimer"
    >
      <span className="uppercase tracking-[0.2em] text-[10px] text-slate-500 block mb-1">
        {t("disclaimer.title")}
      </span>
      {t("disclaimer.text")}
    </div>
  );
}
